import React from 'react';
import { Guideline } from '../../types/profileTypes';
import { BaseRequirementCard } from './BaseRequirementCard';
import { getSummaryText } from './utils';

interface AvoidRestrictedTextForClaimsCardProps {
  guideline: Guideline;
  index: number;
  onEditClick: () => void;
}

export const AvoidRestrictedTextForClaimsCard: React.FC<AvoidRestrictedTextForClaimsCardProps> = ({
  guideline,
  index,
  onEditClick
}) => {
  // Type guard to ensure we have the right guideline type
  if (guideline.type !== 'AvoidRestrictedTextForClaims') {
    return null;
  }

  const summaryText = getSummaryText(guideline);

  return (
    <BaseRequirementCard
      index={index}
      summaryText={summaryText}
      title={guideline.name}
      requirementTypeLabel="Avoid Restricted Text for Product Claims"
      onEditClick={onEditClick}
    />
  );
};
